import React, { PureComponent } from 'react';
import { string, func, number } from 'prop-types';
import { compose } from 'redux';
import { graphql } from 'react-apollo';
import { MUTATION_CREATE_SHARE } from 'api/share';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from 'react-share';
import { Dropdown, Online } from 'common/components';
import * as icons from 'common/svg/icons';
import { graphQlToFormErrors } from 'common/utils';
import { capitalizeString } from 'common/utils';
import { ANALYTICS } from 'common/constants';
import mixpanel from 'mixpanel-browser';

const shareData = [
  { label: 'Facebook', icon: icons.facebook, button: FacebookShareButton },
  { label: 'Twitter', icon: icons.twitter, button: TwitterShareButton },
  { label: 'WhatsApp', icon: icons.whatsapp, button: WhatsappShareButton },
  { label: 'Email', icon: icons.envelope, button: EmailShareButton },
];

export class SocialShare extends PureComponent {
  static displayName = 'SocialShare';

  static propTypes = {
    // should be manually passed on
    id: string.isRequired,
    season: number,
    // from graphql
    onCreateShare: func.isRequired,
  };

  state = { url: '' };

  render() {
    const { url } = this.state;
    return (
      <Online>
        <Dropdown
          theme={['list', 'right', 'invert']}
          trigger={<icons.share onClick={this._handleOnClick} />}
        >
          {shareData && url && (
            <ul>
              {shareData.map((share, idx) => (
                <li key={idx}>
                  <share.button
                    beforeOnClick={() => this._handleAnalytics(share.label)}
                    url={url}
                  >
                    <share.icon />
                    {share.label}
                  </share.button>
                </li>
              ))}
            </ul>
          )}
        </Dropdown>
      </Online>
    );
  }

  _handleAnalytics = shareChannel => {
    const { id } = this.props;
    let type = capitalizeString(id.split(':')[0].toLowerCase());

    mixpanel.track(ANALYTICS.EVENTS.SHARE.SELECTED, {
      [ANALYTICS.PROPERTIES.SHARE.CHANNEL]: shareChannel,
      [ANALYTICS.PROPERTIES.SHARE.TYPE]: type,
    });
  };

  // everytime onclick happens, uuid changes
  _handleOnClick = async () => {
    // if url is already generated, do nothing
    if (this.state.url !== '') {
      return;
    }

    const { id, season, onCreateShare } = this.props;
    const res = await onCreateShare(id, season);
    // set the URL on landing
    if (res && res.data && res.data.createShareForId) {
      this.setState({ url: res.data.createShareForId });
    }
  };
}

export default compose(
  graphql(MUTATION_CREATE_SHARE, {
    props: props => ({
      onCreateShare: (id, season) => {
        return props
          .mutate({
            variables: { id, season },
          })
          .then(res => res)
          .catch(graphQlToFormErrors);
      },
      ...props,
    }),
  })
)(SocialShare);



// WEBPACK FOOTER //
// ./src/containers/SocialShare/index.js